
(function () {
  'use strict';
  
  /**
   * @ngdoc service
   * @name vcdms.vcdoctype.factory:DoctypeHelper
   *
   * @description
   *
   */
  angular
    .module('vcdms.vcdoctype')
    .factory('DoctypeHelper', DoctypeHelper);
  
  
  DoctypeHelper.$inject = ['Doctype', '$uibModal', '$log', 'Rlog'];
  
  function DoctypeHelper(Doctype, $uibModal, $log, Rlog) {
    let DoctypeHelperBase = {};
    
    DoctypeHelperBase.editDoctype = editDoctype;
    DoctypeHelperBase.addDoctype = addDoctype;
    
    
    function addDoctype(success, error) {
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><doctypeform doctype="vm.doctype" parentsave="vm.childsave(doctype)" oncancel="vm.cancel()"></doctypenew></div>',
        controllerAs: 'doctypeaCtrl',
        controller: ['doctype', function () {
          let vm = this;
          vm.doctype = {};
          
          vm.childsave = childsave;
          vm.cancel = cancel;
          
          function childsave(doctype) {
            Doctype.$create(doctype).$then(function (newdoctype) {
              vm.created = true;
              success(newdoctype);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ doctype-helper.addDoctype: ', err);
              Rlog.error('vcutils.doctype', 'doctype-helper.addDoctype', 'Creation of new new Doctype failed: ', {doctype: doctype});
              error(err);
              dialog.close();
            });
          }
          
          function cancel() {
            dialog.close();
          }
          
        }],
        resolve: {
          doctype: function () {
            return {};
          }
        },
        size: 'lg'
      });
    }
    
    
    function editDoctype(ldoctype) {
      let dialog = $uibModal.open({
        template: `
          <div class="modalspacer">
             <doctypeform doctype="doctypeeCtrl.doctype" parentsave="doctypeeCtrl.childsave(doctype)"
                          oncancel="doctypeeCtrl.cancel()"></doctypeform>
          </div>`,
        controllerAs: 'doctypeeCtrl',
        controller: ['doctype', function (sdoctype) {
          let vm = this;
          vm.doctype = sdoctype;
          vm.childsave = childsave;
          vm.cancel = cancel;
          
          
          function childsave(doctype) {
            // vm.doctype = angular.copy(doctype);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (let key in doctype) {
              if (doctype.hasOwnProperty(key)) {
                vm.doctype[key] = doctype[key];
              }
            }
            
            if (vm.doctype.$hasPendingActions()) {
              vm.doctype.$cancel();
              vm.doctype.$save();
              cancel();
            }
            else {
              vm.doctype.$save();
              dialog.close();
            }
          }
          
          
          function cancel() {
            dialog.close();
          }
          
          
        }],
        resolve: {
          doctype: function () {
            return ldoctype;
          }
        },
        size: 'lg'
      });
      return dialog;
    }
    
    return DoctypeHelperBase;
  }
}());
